import TicketsConfig from './_config/tickets.config';
import TicketsRoutes from './_config/tickets.routes';
import TicketsComponent from './components/tickets';
import AnnulationPopupComponent from './components/annulation-popup';
import TicketImportComponent from './components/ticket-import';
import TicketComposantComponent from './components/ticket-composant';
import TicketsService from './services/tickets.service';
import TicketApproService from './services/ticket.appro.service';
import TicketsCommunicationService from './services/tickets.communication.service';

import TicketDetailComponent from './components/ticket-detail';
import TicketSearch from './components/ticket-search';
import TicketCessionComponent from './components/ticket-cession';
import TicketApproComponent from './components/ticket-appro';
import TicketsExportCsvPopupComponent from './components/tickets-export-csv-popup';
import commentaireComponentModal from './components/commentaire-component-modal';

const moduleName = 'app.massia.common.tickets';

angular
	.module(moduleName, [])
	.config(TicketsConfig)
	.config(TicketsRoutes)
	.service('TicketsService', TicketsService)
	.service('TicketApproService', TicketApproService)
	.service('TicketsCommunicationService', TicketsCommunicationService)
	.component('tickets', TicketsComponent)
	.component('annulationPopup', AnnulationPopupComponent)
	.component('ticketImport', TicketImportComponent)
	.component('ticketComposant', TicketComposantComponent)
	.component('ticketDetail', TicketDetailComponent)
	.component('ticketCession', TicketCessionComponent)
	.component('ticketAppro', TicketApproComponent)
	.component('ticketSearch', TicketSearch)
	.component('ticketsExportCsvPopup', TicketsExportCsvPopupComponent)
	.component('commentaireComponentModal', commentaireComponentModal);

export default moduleName;
